var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.429919 4.13957H6.44824C6.56467 4.13957 6.66546 4.09706 6.7505 4.01196C6.8355 3.92689 6.87818 3.82615 6.87818 3.70972C6.87818 3.59329 6.83553 3.4926 6.7505 3.40741L3.74133 0.398236C3.65631 0.313259 3.55559 0.27063 3.43909 0.27063C3.32259 0.27063 3.22187 0.313259 3.13678 0.398236L0.127606 3.40741C0.0425119 3.4925 0 3.59329 0 3.70972C0 3.82613 0.0425119 3.92689 0.127606 4.01196C0.212795 4.09706 0.313511 4.13957 0.429919 4.13957Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44824 5.86047H0.429919C0.313417 5.86047 0.212701 5.90301 0.127606 5.98801C0.0425119 6.0731 0 6.17382 0 6.29025C0 6.40668 0.0425119 6.50747 0.127606 6.59252L3.13678 9.60164C3.22197 9.68673 3.32268 9.72934 3.43909 9.72934C3.5555 9.72934 3.65631 9.68673 3.74133 9.60164L6.7505 6.59249C6.8355 6.50747 6.87818 6.40668 6.87818 6.29023C6.87818 6.17382 6.83553 6.0731 6.7505 5.98799C6.66548 5.90291 6.56467 5.86047 6.44824 5.86047Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.e318bcbe8fa8197e6cbd545cd8486b4d.svg";
export { ForwardRef as ReactComponent };